module.exports = __webpack_public_path__ + "img/cart-remove-icon.abeecb4b.svg";